export default "__VITE_ASSET__BOOqsuTu__"